export default __webpack_public_path__ + "static/media/5.83bb3048.jpg";